<template>
    <div :class="['status-box', {'status-box--new': isNew}]">

      <div class="box-top">
        <span class="box-tag">{{ status.changeType }}</span>
        <span class="box-title"><i :class="'icon-underreview'"></i> {{status.historyChangeText}}</span>
        <span class="status-box-tag" v-if='status.is_new'>NEW</span>
      </div>
      <template v-if="status.comment">
        <div class="status-box-comment-title">Here is [admin-full-name] comment:</div>
        <div class="status-box-comment" v-html="openLinksInNewTab(status.comment)">
  <!--          <p>{{status.comment}}</p>-->
  <!--          <a v-if='status.article' :href="status.article" class="more">Read article related with this idea</a>-->
        </div>
      </template>
      <span class="box-date">{{status.date}}</span>
    </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
export default {
  props: ['status', 'isNew'],
  name: "IdeaStatusBox",
  methods: {
    openLinksInNewTab: openLinksInNewTab,
  },
}
</script>

<style scoped>

</style>
